// extracted by mini-css-extract-plugin
export default {"addNotesCon":"Notes_addNotesCon__WvBHk","newNoteSummary":"Notes_newNoteSummary__ElvVC","writtenContent":"Notes_writtenContent__YpxWm","addNoteBtn":"Notes_addNoteBtn__cYXdV"};